'use strict';

/**
 * M365 migration options for opted in M356 resellers
 * Documentation can be found here for more details: https://confluence.godaddy.com/x/l21IDw
 */

module.exports = {
  WHITE_LABEL: 0,
  CO_BRANDING: 1
};